import {
  useCallback, useState 
} from "react"

export const useShowShareWith = () => {

  const [shareBtn, setShareBtn] = useState<boolean>(false)


  const showShareBtn = useCallback(() => {
    setShareBtn((shareBtn) => !shareBtn)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shareBtn, setShareBtn])


  return {
    showShareBtn,
    shareBtn
  }
}
